/**
 * amt-tour.js — Alien Milling Technologies Site Tour
 * Upload to: Shopify Admin > Online Store > Themes > Edit Code > Assets
 * Version: 2.0
 */

(function () {
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const STORAGE_KEY      = 'amt_tour_step';
  const NEW_PAGE_KEY     = 'amt_tour_new_page';
  const OVERLAY_FADE_MS  = 500;   // page load dim fade in
  const OVERLAY_SETTLE   = 150;   // buffer after fade before dialog
  const FLASH_OUT_MS     = 200;   // how fast page lights up on Next
  const FLASH_IN_MS      = 250;   // how fast page dims back down
  const FLASH_HOLD_MS    = 90;    // how long page stays lit between flash out/in
  const SPOTLIGHT_MS     = 300;   // spotlight hole open animation
  const SCROLL_WAIT_MS   = 275;   // wait after scroll before spotlight
  const TYPEWRITER_SPEED = 26;    // ms per character
  const isMobile         = () => window.innerWidth < 768;

  // ─── STEP DEFINITIONS ──────────────────────────────────────────────────────
  // pageName : shown in the top-right typewriter when arriving on a new page
  // action   : 'next'  → Next button | 'click' → user must click the element
  const STEPS = [
    {
      id          : 1,
      page        : '/',
      pageName    : 'Homepage',
      btnText     : 'LET\'S GO',
      selector    : '.alien-hud-widget.shipping-countdown-widget',
      desktopOnly : true,
      arrow       : 'bottom',
      tooltip     : {
        title  : 'MISSION CONTROL',
        body   : 'Orders submitted before 2PM PST move to production the same day. Keep an eye on this panel — it keeps your cases on track.',
        action : 'next',
      },
    },
    {
      id             : 2,
      page           : '/',
      pageName       : 'Homepage',
      selector       : '.sidebar-module',
      findByText     : 'Shop by Brand',
      mobileHamFirst : true,
      arrow          : 'right',
      tooltip        : {
        title  : 'SHOP BY BRAND',
        body   : 'These are all the brands we carry. Click any brand to browse their full product lineup.',
        action : 'next',
      },
    },
    {
      id      : 3,
      page    : '/',
      pageName: 'Homepage',
      selector: '.sidebar-module',
      findByText     : 'Shop by Type',
      mobileHamFirst : true,
      arrow          : 'right',
      tooltip : {
        title  : 'SHOP BY TYPE',
        body   : 'This is probably the most important menu — it\'s the easiest way to see all the products we offer and quickly choose your restoration type.',
        action : 'next',
      },
    },
    {
      id      : 4,
      page    : '/',
      pageName: 'Homepage',
      selector: null,
      _infoOnly: true,
      tooltip : {
        title  : 'ORDERING A CROWN',
        body   : 'We will run through an example of ordering a crown. You can apply this to any other type of restoration since they are ordered almost the same way.',
        action : 'next',
      },
    },
    {
      id      : 5,
      page    : '/',
      pageName: 'Homepage',
      selector: '.sidebar-module__list a[href="/collections/full-solid-zirconia"]',
      mobileHamFirst: true,
      arrow   : 'right',
      tooltip : {
        title  : 'FULL SOLID CROWNS',
        body   : 'Click here to browse our Full Solid Crown options and follow along with the example.',
        action : 'click',
        cueText: 'CLICK FULL SOLID CROWNS',
        cueArrow: 'left',
      },
    },
    {
      id      : 6,
      page    : '/collections/full-solid-zirconia',
      pageName: 'Full Solid Crowns Page',
      selector: 'a.grid-link[href*="alien-solid-zirconia"]',
      arrow   : 'left',
      tooltip : {
        title   : 'ALIEN HT CROWN',
        body    : 'Here\'s the Alien HT Crown — one of our most popular. Click on it to see product details and start your order.',
        action  : 'click',
        cueText : 'CLICK THE ALIEN HT CROWN',
        cueArrow: 'right',
      },
    },
    {
      id      : 7,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      btnText : 'LET\'S GO',
      selector: '.bold_options',
      arrow   : 'left',
      tooltip : {
        title: 'THE WORK ORDER',
        body : 'This is the work order you will fill out for each case. Every field here tells us exactly how to mill and finish your restoration.',
        action: 'next',
      },
    },
    {
      id      : 8,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_textbox',
      arrow   : 'right',
      tooltip : {
        title    : 'CASE ID',
        body     : 'Enter the Case ID for this case. This is what comes back with your restoration so you can identify it. Use patient initials, a chart number, or any reference. <strong>Try typing &quot;Test&quot; to continue.</strong>',
        action   : 'next',
        validate : () => {
          const inp = document.querySelector('input[name="properties[Case ID]"]');
          if (!inp || inp.value.trim() === '') {
            inp && (inp.style.border = '2px solid #ff3c6e');
            return 'Please enter a Case ID to continue.';
          }
          inp.style.border = '';
          return null;
        },
      },
    },
    {
      id      : 9,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_dropdown',
      arrow   : 'right',
      tooltip : {
        title    : 'SHADE SELECTION',
        body     : 'Select a shade for your case. Choose from 16 classical shades or White for absolute white. <strong>Pick any shade to continue.</strong>',
        action   : 'next',
        validate : () => {
          const sel = document.querySelector('select[name="properties[Shade]"]');
          if (!sel || sel.value === '') {
            sel && (sel.style.border = '2px solid #ff3c6e');
            return 'Please select a shade to continue.';
          }
          sel.style.border = '';
          return null;
        },
      },
    },
    {
      id      : 10,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_radio',
      arrow   : 'right',
      tooltip : {
        title : 'CASE DATA',
        body  : 'This is where you tell us how you\'ll get your case data to us. You can upload an STL, ship models or impressions, send via intra-oral scanner, or upload jaw scans for our design service.',
        action: 'next',
      },
    },
    {
      id      : 11,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Upload STL',
      arrow   : 'right',
      tooltip : {
        title      : 'UPLOAD STL',
        body       : 'If you have your crown already designed and have an STL file ready, select Upload STL.',
        action     : 'click',
        samePageClick: true,
        cueText    : 'SELECT UPLOAD STL',
        cueArrow   : 'right',
      },
    },
    {
      id      : 12,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: 'button.uploadkit-button',
      arrow   : 'right',
      tooltip : {
        title : 'UPLOAD YOUR FILE',
        body  : 'This button appears after selecting Upload STL. Click it to upload your STL file directly from your computer, Google Drive, or Dropbox.',
        action: 'next',
      },
    },
    {
      id      : 13,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Ship Models',
      arrow   : 'right',
      tooltip : {
        title : 'SHIP MODELS',
        body  : 'If you want to send us physical models — articulated and die trimmed — select Ship Models. We\'ll provide shipping instructions after checkout.',
        action: 'next',
      },
    },
    {
      id      : 14,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Ship Impression',
      arrow   : 'right',
      tooltip : {
        title : 'SHIP IMPRESSION',
        body  : 'If you want to send us physical impressions, select Ship Impressions. We\'ll pour and articulate the models in-house.',
        action: 'next',
      },
    },
    {
      id      : 15,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Intra-Oral Scanner',
      arrow   : 'right',
      tooltip : {
        title      : 'INTRA-ORAL SCANNER',
        body       : 'If you send digital scans through your intra-oral scanner, select Intra-Oral Scanner — then we\'ll ask which portal to find your case in.',
        action     : 'click',
        samePageClick: true,
        cueText    : 'SELECT INTRA-ORAL SCANNER',
        cueArrow   : 'right',
      },
    },
    {
      id      : 16,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: 'select[name="properties[IO Portal]"]',
      arrow   : 'right',
      tooltip : {
        title : 'IO SCANNER PORTAL',
        body  : 'Select your scanner from the dropdown so our team knows exactly which portal to pull your case from. We support 3Shape, iTero, MeditLink, DS Core, and more.',
        action: 'next',
      },
    },
    {
      id      : 17,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Upload Jaw Scans',
      arrow   : 'right',
      tooltip : {
        title : 'UPLOAD JAW SCANS',
        body  : 'If you have your digital scans already exported as STL files, you can upload the upper and lower jaw scans directly and our team will handle the design.',
        action: 'next',
      },
    },
    {
      id      : 18,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_value',
      findByText: 'Ship Models',
      arrow   : 'right',
      tooltip : {
        title      : 'TUTORIAL — SELECT SHIP MODELS',
        body       : 'For this tutorial, let\'s select Ship Models so we can continue without uploading a file. In a real order you would choose the method that fits your workflow.',
        action     : 'click',
        samePageClick: true,
        cueText    : 'SELECT SHIP MODELS',
        cueArrow   : 'right',
      },
    },
    {
      id      : 19,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_radio',
      findByText: 'Finishing',
      arrow   : 'right',
      tooltip : {
        title      : 'FINISHING',
        body       : 'If you want your crown stained and glazed to match the shade you selected, click Stain and Glazed. Otherwise select No Finishing for an unglazed restoration.',
        action     : 'click',
        samePageClick: true,
        cueText    : 'SELECT STAIN AND GLAZED',
        cueArrow   : 'right',
        clickTarget: 'input[name="properties[Finishing]"][value="Stain and Glazed"]',
      },
    },
    {
      id      : 20,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_textarea',
      arrow   : 'right',
      tooltip : {
        title : 'SPECIFIC INSTRUCTIONS',
        body  : 'If you have any specific instructions for this case — tooth numbers, bridge configuration, special notes — this is where you type them.',
        action: 'next',
      },
    },
    {
      id      : 21,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.bold_option_total',
      arrow   : 'right',
      tooltip : {
        title : 'EXTRA CHARGES',
        body  : 'Since we added Ship Models and Stain & Glaze finishing, you can see any additional charges for this case here on top of the base milling price.',
        action: 'next',
      },
    },
    {
      id      : 22,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '.product-single__quantity',
      arrow   : 'right',
      tooltip : {
        title : 'NUMBER OF UNITS',
        body  : 'Enter the number of units for your case. Single crown? Leave it at 1. 3-unit bridge? Change the quantity to 3.',
        action: 'next',
      },
    },
    {
      id      : 23,
      page    : '/collections/full-solid-zirconia/products/alien-solid-zirconia',
      pageName: 'Alien HT Solid Zirconia Page',
      selector: '#AddToCart.bold_clone',
      arrow   : 'top',
      tooltip : {
        title      : 'ADD TO CART',
        body       : 'Your work order is complete — let\'s add it to the cart!',
        action     : 'click',
        cartClick  : true,
        cueText    : 'CLICK ADD TO CART',
        cueArrow   : 'down',
      },
    },
    {
      id      : 24,
      page    : '/cart',
      pageName: 'Your Cart',
      btnText : 'FINISH TOUR',
      selector: '.cart__row.bold-row',
      arrow   : 'bottom',
      tooltip : {
        title : 'CASE ADDED! 🛸',
        body  : 'Here is the case you just added. You can add more cases using the same workflow and checkout all at once — no need to checkout per case. <br><br><strong>Thank you for taking the Alien Interactive Tour. We look forward to working with you!</strong>',
        action: 'end',
      },
    },
  ];

  // ─── STATE ─────────────────────────────────────────────────────────────────
  let currentStep  = null;
  let activeEl     = null;
  let overlayEl    = null;
  let tooltipEl    = null;
  let announceEl   = null;
  let hamSubStep   = false;
  let isNewPage    = false;  // true when we just navigated to this page mid-tour

  // ─── INIT ──────────────────────────────────────────────────────────────────
  function init() {
    const params = new URLSearchParams(window.location.search);
    const stored = sessionStorage.getItem(STORAGE_KEY);

    if (params.get('amt_tour') === 'start') {
      sessionStorage.setItem(STORAGE_KEY, '1');
      sessionStorage.removeItem(NEW_PAGE_KEY);
      currentStep = 1;
      isNewPage   = true;
      history.replaceState({}, '', window.location.pathname);
      publishEvent('tour_started');
    } else if (stored) {
      currentStep = parseInt(stored, 10);
      isNewPage   = sessionStorage.getItem(NEW_PAGE_KEY) === '1';
      sessionStorage.removeItem(NEW_PAGE_KEY);
    }

    if (!currentStep) return;

    injectFonts();
    injectStyles();
    buildDOM();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(startSequence, 150));
    } else {
      setTimeout(startSequence, 150);
    }
  }

  // ─── MOBILE WARNING ────────────────────────────────────────────────────────
  function showMobileWarning() {
    // Clean up sessionStorage so tour doesn't persist
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(NEW_PAGE_KEY);

    injectFonts();
    injectStyles();
    buildDOM();

    // Full dim
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const svg     = document.getElementById('amt-svg');
    const svgPath = document.getElementById('amt-svg-path');
    svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    svg.style.width  = vw + 'px';
    svg.style.height = vh + 'px';
    svgPath.setAttribute('d', `M0 0 H${vw} V${vh} H0 Z`);
    overlayEl.style.opacity = '1';
    overlayEl.classList.add('active');

    tooltipEl.innerHTML = `
      <div class="amt-tt-head">
        <span class="amt-tt-counter">👽 ALIEN TOUR</span>
        <button class="amt-tt-close" id="amt-close">✕</button>
      </div>
      <div class="amt-tt-title">BEST ON DESKTOP</div>
      <div class="amt-tt-body">
        The Alien Interactive Tour is designed for desktop browsers where all menus and panels are fully visible.<br><br>
        For the best experience, <strong>visit us on a desktop or laptop</strong> to take the full tour.
      </div>
      <div class="amt-tt-foot">
        <button class="amt-btn-next" id="amt-mobile-shop">GO TO THE SHOP &nbsp;→</button>
        <button class="amt-btn-end"  id="amt-mobile-close">CLOSE</button>
      </div>
    `;

    tooltipEl.style.width     = 'calc(100vw - 32px)';
    tooltipEl.style.left      = '16px';
    tooltipEl.style.right     = '16px';
    tooltipEl.style.top       = '50%';
    tooltipEl.style.bottom    = 'auto';
    tooltipEl.style.transform = 'translate(0, -50%)';
    tooltipEl.style.opacity   = '0';
    tooltipEl.style.display   = 'block';

    requestAnimationFrame(() => {
      tooltipEl.style.transition = 'opacity 0.3s ease';
      tooltipEl.style.opacity    = '1';
    });

    const dismiss = () => {
      overlayEl.style.transition = 'opacity 0.3s ease';
      overlayEl.style.opacity    = '0';
      tooltipEl.style.opacity    = '0';
      setTimeout(() => {
        overlayEl.classList.remove('active');
        tooltipEl.style.display = 'none';
        const ind = document.getElementById('amt-tour-indicator');
        if (ind) ind.remove();
      }, 300);
    };

    document.getElementById('amt-close')       ?.addEventListener('click', dismiss);
    document.getElementById('amt-mobile-close') ?.addEventListener('click', dismiss);
    document.getElementById('amt-mobile-shop')  ?.addEventListener('click', () => {
      dismiss();
      setTimeout(() => { window.location.href = '/collections/all'; }, 300);
    });
  }

  // ─── START SEQUENCE (on page load) ─────────────────────────────────────────
  function startSequence() {

    // Mobile — show "best on desktop" dialog and do nothing else
    if (isMobile()) {
      showMobileWarning();
      return;
    }

    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // Draw full-screen dark rectangle immediately but invisible
    const svg     = document.getElementById('amt-svg');
    const svgPath = document.getElementById('amt-svg-path');
    svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    svg.style.width  = vw + 'px';
    svg.style.height = vh + 'px';
    svgPath.setAttribute('d', `M0 0 H${vw} V${vh} H0 Z`);

    if (isNewPage) {
      // Fade overlay in then go straight to activateStep
      overlayEl.style.transition = 'none';
      overlayEl.style.opacity    = '0';
      overlayEl.classList.add('active');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          overlayEl.style.transition = `opacity ${OVERLAY_FADE_MS}ms ease`;
          overlayEl.style.opacity    = '1';
          setTimeout(activateStep, OVERLAY_FADE_MS + OVERLAY_SETTLE);
        });
      });

    } else {
      // Same page — snap dark instantly, no transition
      overlayEl.style.transition = 'none';
      overlayEl.style.opacity    = '1';
      overlayEl.classList.add('active');
      activateStep();
    }
  }

  // ─── FLASH AND DIM ─────────────────────────────────────────────────────────
  function flashAndDim(onDone) {
    overlayEl.style.transition = `opacity ${FLASH_OUT_MS}ms ease`;
    overlayEl.style.opacity    = '0';
    setTimeout(() => {
      setTimeout(() => {
        overlayEl.style.transition = `opacity ${FLASH_IN_MS}ms ease`;
        overlayEl.style.opacity    = '1';
        setTimeout(() => { if (onDone) onDone(); }, FLASH_IN_MS);
      }, FLASH_HOLD_MS);
    }, FLASH_OUT_MS);
  }

  // ─── ACTIVATE CURRENT STEP ─────────────────────────────────────────────────
  function activateStep() {
    const step = STEPS.find(s => s.id === currentStep);
    if (!step) { endTour(); return; }

  // ─── VALIDATION ERROR ──────────────────────────────────────────────────────
  function showValidationError(msg) {
    let errEl = document.getElementById('amt-validation-err');
    if (errEl) errEl.remove();
    errEl    = document.createElement('div');
    errEl.id = 'amt-validation-err';
    errEl.textContent = '⚠ ' + msg;
    errEl.style.cssText = 'color:#ff3c6e;font-family:\'Orbitron\',monospace;font-size:10px;letter-spacing:1px;padding:8px 0 4px;';
    const foot = tooltipEl.querySelector('.amt-tt-foot');
    if (foot) foot.prepend(errEl);
    setTimeout(() => { const e = document.getElementById('amt-validation-err'); if (e) e.remove(); }, 3000);
  }

  // ─── ACTIVATE CURRENT STEP ─────────────────────────────────────────────────

    // Wrong page — navigate
    const path = window.location.pathname.replace(/\/$/, '');
    const need = (step.page || '/').replace(/\/$/, '');
    if (need && need !== '' && !path.startsWith(need)) {
      sessionStorage.setItem(STORAGE_KEY, currentStep);
      sessionStorage.setItem(NEW_PAGE_KEY, '1');
      window.location.href = need;
      return;
    }

    // Mobile hamburger sub-step
    if (step.mobileHamFirst && isMobile() && !isSidebarOpen() && !hamSubStep) {
      showHamburgerStep(step);
      return;
    }

    hamSubStep = false;

    // Info-only step — no element to spotlight, just show a centered dialog
    if (step._infoOnly) {
      showInfoDialog(step);
      return;
    }

    const el = findEl(step);
    if (!el) {
      console.warn('[AMT Tour] Element not found:', step.selector, step.findByText);
      return;
    }

    spotlight(el, step);
  }

  // ─── INFO DIALOG (no spotlight) ────────────────────────────────────────────
  // For steps that just need to say something before moving on.
  function showInfoDialog(step) {
    // Close any existing spotlight hole — just full dark overlay
    const svgPath = document.getElementById('amt-svg-path');
    const vw = window.innerWidth, vh = window.innerHeight;
    if (svgPath) svgPath.setAttribute('d', `M0 0 H${vw} V${vh} H0 Z`);
    const svgRing = document.getElementById('amt-svg-ring');
    if (svgRing) { svgRing.setAttribute('width','0'); svgRing.setAttribute('height','0'); }

    const visible = isMobile() ? STEPS.filter(s => !s.desktopOnly) : STEPS;
    const idx     = visible.findIndex(s => s.id === step.id);
    const counter = idx >= 0 ? `STEP ${idx + 1} / ${visible.length}` : 'INFO';

    tooltipEl.innerHTML = `
      <div class="amt-tt-head">
        <span class="amt-tt-counter">${counter}</span>
        <button class="amt-tt-close" id="amt-close">✕</button>
      </div>
      <div class="amt-tt-title">${step.tooltip.title}</div>
      <div class="amt-tt-body">${step.tooltip.body}</div>
      <div class="amt-tt-foot">
        <button class="amt-btn-next" id="amt-next">NEXT &nbsp;→</button>
        <button class="amt-btn-end"  id="amt-end">END TOUR</button>
      </div>
    `;

    // Center on screen
    tooltipEl.style.width     = '340px';
    tooltipEl.style.top       = '50%';
    tooltipEl.style.left      = '50%';
    tooltipEl.style.bottom    = 'auto';
    tooltipEl.style.right     = 'auto';
    tooltipEl.style.transform = 'translate(-50%, -50%)';

    tooltipEl.style.opacity   = '0';
    tooltipEl.style.display   = 'block';
    requestAnimationFrame(() => {
      tooltipEl.style.transition = 'opacity 0.35s ease';
      tooltipEl.style.opacity    = '1';
    });

    document.getElementById('amt-close')?.addEventListener('click', endTour);
    document.getElementById('amt-end')  ?.addEventListener('click', endTour);
    document.getElementById('amt-next') ?.addEventListener('click', () => {
      tooltipEl.style.transform = '';
      tooltipEl.style.top       = '';
      tooltipEl.style.left      = '';
      hideTooltip();
      setTimeout(advance, 175);
    });
  }


  function findEl(step) {
    let el = null;

    if (step.findByText) {
      const all = document.querySelectorAll(step.selector);
      for (const candidate of all) {
        if (candidate.textContent && candidate.textContent.includes(step.findByText)) {
          el = candidate; break;
        }
      }
    } else {
      // Pick first match that is actually visible on screen
      const all = document.querySelectorAll(step.selector);
      for (const candidate of all) {
        const r = candidate.getBoundingClientRect();
        const s = getComputedStyle(candidate);
        if (r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden') {
          el = candidate; break;
        }
      }
      if (!el) el = document.querySelector(step.selector);
    }

    if (!el) {
      console.warn('[AMT Tour] Element not found:', step.selector);
      return null;
    }

    return el;
  }

  function isSidebarOpen() {
    // Desktop — sidebar always visible
    if (!isMobile()) return true;
    // Mobile — check if the nav drawer is open (Shopify themes add classes like is-open, active, open)
    const nav = document.getElementById('MobileNav') ||
                document.querySelector('.mobile-nav') ||
                document.querySelector('[id*="mobile-nav"]') ||
                document.querySelector('[class*="mobile-nav"]');
    if (!nav) return false;
    const style = getComputedStyle(nav);
    const r     = nav.getBoundingClientRect();
    return style.display !== 'none' &&
           style.visibility !== 'hidden' &&
           parseFloat(style.opacity) > 0 &&
           r.height > 0;
  }

  // ─── HAMBURGER SUB-STEP ────────────────────────────────────────────────────
  function showHamburgerStep(nextStep) {
    hamSubStep = true;

    const ham =
      document.getElementById('MobileNavTrigger') ||
      document.querySelector('.mobile-nav-trigger') ||
      document.querySelector('.icon-hamburger')?.closest('button') ||
      document.querySelector('[class*="hamburger"]')?.closest('button') ||
      document.querySelector('[class*="menu-toggle"]');

    if (!ham) { hamSubStep = false; activateStep(); return; }

    spotlight(ham, {
      arrow  : 'bottom',
      tooltip: {
        title  : 'OPEN THE MENU',
        body   : `Tap the menu icon to open the navigation — we\'ll show you ${nextStep.tooltip.title} inside.`,
        action : 'click',
        cueText: 'TAP THE MENU ICON',
        cueArrow: 'up',
      },
    }, () => {
      // Wait for the mobile nav animation to finish before looking for sidebar elements
      setTimeout(() => {
        hamSubStep = false;
        activateStep();
      }, 500);
    });
  }

  // ─── SPOTLIGHT ─────────────────────────────────────────────────────────────
  function spotlight(el, step, clickCb) {
    activeEl = null; // clear so scroll events don't fire drawSpotlightExact during animation

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      animateSpotlight(el, () => {
        activeEl = el; // only set AFTER animation so resize/scroll handlers are safe
        renderTooltip(el, step, clickCb);
      });
    }, SCROLL_WAIT_MS);
  }

  // Animate the spotlight hole opening from zero size to full size
  function animateSpotlight(el, onDone) {
    const pad   = 14;
    const br    = 6;
    const r     = el.getBoundingClientRect();
    const vw    = window.innerWidth;
    const vh    = window.innerHeight;
    const tX    = r.left   - pad;
    const tY    = r.top    - pad;
    const tW    = r.width  + pad * 2;
    const tH    = r.height + pad * 2;

    // Start from center of target — hole is 0 size
    const cX    = tX + tW / 2;
    const cY    = tY + tH / 2;

    const svgPath = document.getElementById('amt-svg-path');
    const svgRing = document.getElementById('amt-svg-ring');
    const svg     = document.getElementById('amt-svg');
    if (!svgPath || !svgRing || !svg) return;

    svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    svg.style.width  = vw + 'px';
    svg.style.height = vh + 'px';

    const startTime = performance.now();

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3); // cubic ease out
    }

    function frame(now) {
      const elapsed  = now - startTime;
      const progress = Math.min(elapsed / SPOTLIGHT_MS, 1);
      const ease     = easeOut(progress);

      const x = cX - (tW / 2) * ease;
      const y = cY - (tH / 2) * ease;
      const w = tW * ease;
      const h = tH * ease;

      if (w < 1 || h < 1) {
        // Draw a tiny dot to avoid SVG glitches at 0 size
        svgPath.setAttribute('d', `M0 0 H${vw} V${vh} H0 Z`);
        svgRing.setAttribute('width',  '0');
        svgRing.setAttribute('height', '0');
      } else {
        svgPath.setAttribute('d',
          `M0 0 H${vw} V${vh} H0 Z ` +
          `M${x + br} ${y} ` +
          `H${x + w - br} Q${x + w} ${y} ${x + w} ${y + br} ` +
          `V${y + h - br} Q${x + w} ${y + h} ${x + w - br} ${y + h} ` +
          `H${x + br} Q${x} ${y + h} ${x} ${y + h - br} ` +
          `V${y + br} Q${x} ${y} ${x + br} ${y} Z`
        );
        svgRing.setAttribute('x',      x);
        svgRing.setAttribute('y',      y);
        svgRing.setAttribute('width',  w);
        svgRing.setAttribute('height', h);
        svgRing.setAttribute('rx',     br);
      }

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        drawSpotlightExact(el);
        if (onDone) onDone();
      }
    }

    requestAnimationFrame(frame);
  }

  // Draw spotlight at exact final position (used for resize/scroll updates)
  function drawSpotlightExact(el) {
    const pad = 14;
    const r   = el.getBoundingClientRect();
    const vw  = window.innerWidth;
    const vh  = window.innerHeight;
    const x   = r.left   - pad;
    const y   = r.top    - pad;
    const w   = r.width  + pad * 2;
    const h   = r.height + pad * 2;
    const br  = 6;

    const svgPath = document.getElementById('amt-svg-path');
    const svgRing = document.getElementById('amt-svg-ring');
    const svg     = document.getElementById('amt-svg');
    if (!svgPath || !svgRing || !svg) return;

    svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    svg.style.width  = vw + 'px';
    svg.style.height = vh + 'px';

    svgPath.setAttribute('d',
      `M0 0 H${vw} V${vh} H0 Z ` +
      `M${x + br} ${y} ` +
      `H${x + w - br} Q${x + w} ${y} ${x + w} ${y + br} ` +
      `V${y + h - br} Q${x + w} ${y + h} ${x + w - br} ${y + h} ` +
      `H${x + br} Q${x} ${y + h} ${x} ${y + h - br} ` +
      `V${y + br} Q${x} ${y} ${x + br} ${y} Z`
    );

    svgRing.setAttribute('x',      x);
    svgRing.setAttribute('y',      y);
    svgRing.setAttribute('width',  w);
    svgRing.setAttribute('height', h);
    svgRing.setAttribute('rx',     br);
  }

  // ─── TOOLTIP ───────────────────────────────────────────────────────────────
  function renderTooltip(el, step, clickCb) {
    if (!step || !step.tooltip) return;

    const visible = isMobile() ? STEPS.filter(s => !s.desktopOnly) : STEPS;
    const idx     = visible.findIndex(s => s.id === currentStep);
    const counter = idx >= 0 ? `STEP ${idx + 1} / ${visible.length}` : 'INFO';
    const isClick = step.tooltip.action === 'click';
    const isEnd   = step.tooltip.action === 'end';

    tooltipEl.innerHTML = `
      <div class="amt-tt-head">
        <span class="amt-tt-counter">${counter}</span>
        <button class="amt-tt-close" id="amt-close">✕</button>
      </div>
      <div class="amt-tt-title">${step.tooltip.title}</div>
      <div class="amt-tt-body">${step.tooltip.body}</div>
      <div class="amt-tt-foot">
        ${isEnd
          ? `<button class="amt-btn-next" id="amt-end-final">END TOUR &nbsp;✓</button>`
          : isClick
          ? (() => {
              const cueText  = (step.tooltip.cueText)  || 'CLICK THE HIGHLIGHTED ITEM';
              const cueArrow = (step.tooltip.cueArrow) || 'down';
              const arrows   = {
                down : 'M12 5v14M5 12l7 7 7-7',
                left : 'M19 12H5M12 5l-7 7 7 7',
                right: 'M5 12h14M12 5l7 7-7 7',
                up   : 'M12 19V5M5 12l7-7 7 7',
              };
              const d = arrows[cueArrow] || arrows.down;
              return `<div class="amt-click-cue">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="#00e5ff" stroke-width="2"><path d="${d}"/></svg>
                ${cueText}
              </div>`;
            })()
          : `<button class="amt-btn-next" id="amt-next">NEXT &nbsp;→</button>`
        }
        ${!isEnd ? `<button class="amt-btn-end" id="amt-end">END TOUR</button>` : ''}
      </div>
    `;

    positionTooltip(el, step.arrow || 'right');

    document.getElementById('amt-close')    ?.addEventListener('click', endTour);
    document.getElementById('amt-end')      ?.addEventListener('click', endTour);
    document.getElementById('amt-end-final')?.addEventListener('click', () => endTour(true));
    document.getElementById('amt-next') ?.addEventListener('click', () => {
      // Run validation if defined on this step
      if (step.tooltip.validate) {
        const err = step.tooltip.validate();
        if (err) {
          showValidationError(err);
          return;
        }
      }
      advance();
    });

    // Shake animation on clickable elements so user knows what to interact with
    if (isClick && el) {
      el.classList.add('amt-shake');
      setTimeout(() => el.classList.remove('amt-shake'), 600);
    }

    if (isClick) {
      const clickEl = step.tooltip.clickTarget
        ? (document.querySelector(step.tooltip.clickTarget) || el)
        : el;

      const onElClick = (e) => {
        clickEl.removeEventListener('click', onElClick, true);
        if (clickCb) {
          e.preventDefault();
          clickCb();
        } else if (step.tooltip.cartClick) {
          const form = el.closest('form') || document.getElementById('AddToCartForm');
          if (form && !form.querySelector('input[name="return_to"]')) {
            const rt   = document.createElement('input');
            rt.type    = 'hidden';
            rt.name    = 'return_to';
            rt.value   = '/cart';
            form.appendChild(rt);
          }
          sessionStorage.setItem(STORAGE_KEY, currentStep + 1);
          sessionStorage.setItem(NEW_PAGE_KEY, '1');
          hideTooltip();
        } else if (step.tooltip.samePageClick) {
          hideTooltip();
          setTimeout(() => advance(), 250);
        } else {
          sessionStorage.setItem(STORAGE_KEY, currentStep + 1);
          sessionStorage.setItem(NEW_PAGE_KEY, '1');
        }
      };
      clickEl.addEventListener('click', onElClick, true);
    }

    tooltipEl.style.opacity   = '0';
    tooltipEl.style.transform = 'translateY(12px)';
    tooltipEl.style.display   = 'block';
    requestAnimationFrame(() => {
      tooltipEl.style.opacity   = '1';
      tooltipEl.style.transform = 'translateY(0)';
    });
  }

  function positionTooltip(el, prefer) {
    const margin = 20;
    const ttW    = 310;
    const ttH    = 240;
    const r      = el.getBoundingClientRect();
    const vw     = window.innerWidth;
    const vh     = window.innerHeight;

    if (isMobile()) {
      tooltipEl.style.left   = margin + 'px';
      tooltipEl.style.top    = 'auto';
      tooltipEl.style.bottom = margin + 'px';
      tooltipEl.style.right  = margin + 'px';
      tooltipEl.style.width  = `calc(100vw - ${margin * 2}px)`;
      return;
    }

    tooltipEl.style.width  = ttW + 'px';
    tooltipEl.style.bottom = 'auto';
    tooltipEl.style.right  = 'auto';

    let top, left;
    if (prefer === 'right' && r.right + ttW + margin < vw) {
      left = r.right + margin;
      top  = r.top + r.height / 2 - ttH / 2;
    } else if (prefer === 'left' && r.left - ttW - margin > 0) {
      left = r.left - ttW - margin;
      top  = r.top + r.height / 2 - ttH / 2;
    } else if (prefer === 'bottom' && r.bottom + ttH + margin < vh) {
      left = r.left + r.width / 2 - ttW / 2;
      top  = r.bottom + margin;
    } else if (r.top - ttH - margin > 0) {
      left = r.left + r.width / 2 - ttW / 2;
      top  = r.top - ttH - margin;
    } else {
      left = r.right + margin < vw - ttW ? r.right + margin : r.left - ttW - margin;
      top  = r.top + r.height / 2 - ttH / 2;
    }

    tooltipEl.style.left = Math.max(margin, Math.min(left, vw - ttW - margin)) + 'px';
    tooltipEl.style.top  = Math.max(margin, Math.min(top,  vh - ttH - margin)) + 'px';
  }

  // ─── CLOSE SPOTLIGHT ───────────────────────────────────────────────────────
  // Shrinks the spotlight hole back to zero, then calls onDone.
  function closeSpotlight(onDone) {
    activeEl = null; // stop resize/scroll from redrawing

    const svgPath = document.getElementById('amt-svg-path');
    const svgRing = document.getElementById('amt-svg-ring');
    const vw      = window.innerWidth;
    const vh      = window.innerHeight;

    // Read current hole position from svgRing
    const curX = parseFloat(svgRing.getAttribute('x')  || 0);
    const curY = parseFloat(svgRing.getAttribute('y')  || 0);
    const curW = parseFloat(svgRing.getAttribute('width')  || 0);
    const curH = parseFloat(svgRing.getAttribute('height') || 0);
    const br   = 6;

    const cX = curX + curW / 2;
    const cY = curY + curH / 2;

    const startTime = performance.now();
    const CLOSE_MS  = 350;

    function easeIn(t) { return t * t * t; }

    function frame(now) {
      const elapsed  = now - startTime;
      const progress = Math.min(elapsed / CLOSE_MS, 1);
      const ease     = 1 - easeIn(1 - progress); // ease in = shrink accelerates

      const w = curW * (1 - ease);
      const h = curH * (1 - ease);
      const x = cX - w / 2;
      const y = cY - h / 2;

      if (w < 1 || h < 1) {
        svgPath.setAttribute('d', `M0 0 H${vw} V${vh} H0 Z`);
        svgRing.setAttribute('width',  '0');
        svgRing.setAttribute('height', '0');
      } else {
        svgPath.setAttribute('d',
          `M0 0 H${vw} V${vh} H0 Z ` +
          `M${x + br} ${y} ` +
          `H${x + w - br} Q${x + w} ${y} ${x + w} ${y + br} ` +
          `V${y + h - br} Q${x + w} ${y + h} ${x + w - br} ${y + h} ` +
          `H${x + br} Q${x} ${y + h} ${x} ${y + h - br} ` +
          `V${y + br} Q${x} ${y} ${x + br} ${y} Z`
        );
        svgRing.setAttribute('x', x); svgRing.setAttribute('y', y);
        svgRing.setAttribute('width', w); svgRing.setAttribute('height', h);
        svgRing.setAttribute('rx', br);
      }

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        if (onDone) onDone();
      }
    }

    requestAnimationFrame(frame);
  }


  function advance() {
    let next = currentStep + 1;

    while (next <= STEPS[STEPS.length - 1].id) {
      const s = STEPS.find(s => s.id === next);
      if (!s) { endTour(); return; }
      if (s.desktopOnly && isMobile()) { next++; continue; }
      break;
    }

    if (next > STEPS[STEPS.length - 1].id) { endTour(); return; }

    const prevStep = STEPS.find(s => s.id === currentStep);
    currentStep    = next;
    sessionStorage.setItem(STORAGE_KEY, currentStep);

    const step    = STEPS.find(s => s.id === currentStep);
    publishEvent('tour_step', { step: currentStep, title: step.tooltip.title });
    const curPath = window.location.pathname.replace(/\/$/, '');
    const need    = (step.page || '/').replace(/\/$/, '');

    hideTooltip();

    // Info-only step — just close spotlight and show dialog, no flash/scroll needed
    if (step._infoOnly) {
      closeSpotlight(() => {
        setTimeout(() => showInfoDialog(step), 100);
      });
      return;
    }

    if (need && need !== '' && !curPath.startsWith(need)) {
      sessionStorage.setItem(NEW_PAGE_KEY, '1');
      flashAndDim(() => { window.location.href = need; });
    } else {
      // Same page: close spotlight → flash light → scroll → dim → spotlight
      closeSpotlight(() => {
        // Flash page light
        overlayEl.style.transition = `opacity ${FLASH_OUT_MS}ms ease`;
        overlayEl.style.opacity    = '0';

        setTimeout(() => {
          // Now scroll while page is fully lit
          const el = findEl(step);
          if (!el) {
            // Element not found — re-dim the page and warn in console
            console.warn('[AMT Tour] Element not found for step', currentStep, step.selector, step.findByText);
            overlayEl.style.transition = `opacity ${FLASH_IN_MS}ms ease`;
            overlayEl.style.opacity    = '1';
            return;
          }
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Wait for scroll to settle, then dim back down and open spotlight
          setTimeout(() => {
            overlayEl.style.transition = `opacity ${FLASH_IN_MS}ms ease`;
            overlayEl.style.opacity    = '1';

            setTimeout(() => {
              spotlight(el, step);
            }, FLASH_IN_MS);

          }, SCROLL_WAIT_MS);
        }, FLASH_OUT_MS + FLASH_HOLD_MS);
      });
    }
  }

  // ─── ANALYTICS PUBLISHER ───────────────────────────────────────────────────
  function publishEvent(name, data) {
    try {
      const payload = Object.assign({ event: name, ts: Date.now() }, data || {});

      // GA4 — primary tracking
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          event_category: 'Alien Tour',
          event_label   : data && data.title ? data.title : name,
          tour_step     : data && (data.step || data.last_step) || null,
        });
      }

      // Google Tag Manager dataLayer fallback
      if (window.dataLayer) {
        window.dataLayer.push({
          event          : 'amt_tour',
          amt_tour_action: name,
          amt_tour_step  : data && (data.step || data.last_step) || null,
          amt_tour_title : data && data.title || null,
        });
      }

      // Console log for verification
      console.log('[AMT Tour]', name, payload);

    } catch(e) {}
  }

  function endTour(completed) {
    publishEvent(completed ? 'tour_completed' : 'tour_abandoned', {
      last_step: currentStep,
    });
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(NEW_PAGE_KEY);
    currentStep = null;

    const indicator = document.getElementById('amt-tour-indicator');
    if (indicator) indicator.remove();

    // Fade overlay out
    overlayEl.style.transition = 'opacity 0.6s ease';
    overlayEl.style.opacity    = '0';
    setTimeout(() => {
      overlayEl.classList.remove('active');
      overlayEl.style.opacity    = '';
      overlayEl.style.transition = '';
    }, 600);

    hideTooltip();
    if (announceEl) announceEl.style.display = 'none';
  }

  function hideTooltip() {
    tooltipEl.style.opacity   = '0';
    tooltipEl.style.transform = 'translateY(12px)';
    setTimeout(() => { tooltipEl.style.display = 'none'; }, 150);
  }

  // ─── BUILD DOM ─────────────────────────────────────────────────────────────
  function buildDOM() {
    // Main overlay + SVG
    overlayEl = document.createElement('div');
    overlayEl.id        = 'amt-tour-overlay';
    overlayEl.innerHTML = `
      <svg id="amt-svg" xmlns="http://www.w3.org/2000/svg"
           style="position:fixed;inset:0;width:100%;height:100%;display:block;">
        <defs>
          <filter id="amt-glow-filter" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"/>
            <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
        </defs>
        <path id="amt-svg-path" fill="rgba(2,12,27,0.72)" fill-rule="evenodd"/>
        <rect id="amt-svg-ring" fill="none"
              stroke="#00e5ff" stroke-width="2"
              filter="url(#amt-glow-filter)"/>
      </svg>
    `;

    // Tooltip
    tooltipEl              = document.createElement('div');
    tooltipEl.id           = 'amt-tour-tooltip';
    tooltipEl.style.display = 'none';

    // Page announce (top-right typewriter)
    announceEl              = document.createElement('div');
    announceEl.id           = 'amt-page-announce';
    announceEl.style.display = 'none';

    // Persistent tour indicator — top right corner
    const indicatorEl       = document.createElement('div');
    indicatorEl.id          = 'amt-tour-indicator';
    indicatorEl.innerHTML   = `
      <span class="amt-ind-dot"></span>
      <span class="amt-ind-label">INTERACTIVE TOUR ON</span>
      <button class="amt-ind-end" id="amt-ind-end">✕ END</button>
    `;
    document.body.appendChild(indicatorEl);
    document.getElementById('amt-ind-end')?.addEventListener('click', endTour);

    document.body.appendChild(overlayEl);
    document.body.appendChild(tooltipEl);
    document.body.appendChild(announceEl);

    window.addEventListener('resize', () => { if (activeEl) drawSpotlightExact(activeEl); });
    window.addEventListener('scroll', () => { if (activeEl) drawSpotlightExact(activeEl); }, { passive: true });
  }

  // ─── STYLES ────────────────────────────────────────────────────────────────
  function injectStyles() {
    const s = document.createElement('style');
    s.textContent = `
      #amt-tour-indicator {
        position      : fixed;
        top           : 12px;
        right         : 16px;
        z-index       : 9300;
        display       : flex;
        align-items   : center;
        gap           : 8px;
        background    : rgba(2,12,27,0.92);
        border        : 1px solid #00e5ff44;
        border-left   : 3px solid #00e5ff;
        padding       : 7px 12px;
        backdrop-filter: blur(8px);
        clip-path     : polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px));
        pointer-events: all;
      }
      .amt-ind-dot {
        width        : 6px;
        height       : 6px;
        border-radius: 50%;
        background   : #00ff41;
        box-shadow   : 0 0 8px #00ff41;
        flex-shrink  : 0;
        animation    : amt-cursor-blink 1.4s ease-in-out infinite;
      }
      .amt-ind-label {
        font-family   : 'Orbitron', monospace;
        font-size     : 9px;
        color         : #00e5ff;
        letter-spacing: 2px;
        white-space   : nowrap;
      }
      .amt-ind-end {
        background    : transparent;
        border        : 1px solid #ff3c6e44;
        color         : #ff3c6e;
        font-family   : 'Orbitron', monospace;
        font-size     : 8px;
        letter-spacing: 1px;
        padding       : 3px 8px;
        cursor        : pointer;
        transition    : all 0.2s;
        white-space   : nowrap;
      }
      .amt-ind-end:hover { background: rgba(255,60,110,0.15); border-color: #ff3c6e; }

      #amt-tour-overlay {
        display       : block;
        position      : fixed;
        inset         : 0;
        z-index       : 9000;
        pointer-events: none;
        opacity       : 0;
      }
      #amt-tour-overlay.active { pointer-events: none; }

      /* ── Arrival dialog page name ── */
      .amt-arrive-page {
        font-family   : 'Orbitron', monospace;
        font-size     : 18px;
        font-weight   : 700;
        color         : #00e5ff;
        letter-spacing: 1.5px;
        margin-bottom : 20px;
        min-height    : 28px;
        text-shadow   : 0 0 20px rgba(0,229,255,0.4);
      }
      .amt-arrive-cursor {
        display    : inline-block;
        color      : #00e5ff;
        animation  : amt-cursor-blink 0.7s step-end infinite;
        margin-left: 1px;
      }
      @keyframes amt-cursor-blink {
        0%,100% { opacity:1; } 50% { opacity:0; }
      }

      /* ── Tooltip ── */
      #amt-tour-tooltip {
        position   : fixed;
        z-index    : 9100;
        width      : 310px;
        background : #071428;
        border     : 1px solid #0d2a4e;
        border-left: 3px solid #00e5ff;
        padding    : 22px;
        font-family: 'Rajdhani', sans-serif;
        transition : opacity 0.35s ease, transform 0.35s ease;
        box-shadow : 0 0 50px rgba(0,229,255,0.12), 0 20px 60px rgba(0,0,0,0.6);
        clip-path  : polygon(0 0, calc(100% - 14px) 0, 100% 14px,
                             100% 100%, 14px 100%, 0 calc(100% - 14px));
      }

      .amt-tt-head {
        display        : flex;
        justify-content: space-between;
        align-items    : center;
        margin-bottom  : 10px;
      }
      .amt-tt-counter {
        font-family   : 'Orbitron', monospace;
        font-size     : 10px;
        color         : #00e5ff;
        letter-spacing: 3px;
      }
      .amt-tt-close {
        background: none; border: none;
        color: #5a8a9f; cursor: pointer;
        font-size: 14px; padding: 0;
        line-height: 1; transition: color 0.2s;
      }
      .amt-tt-close:hover { color: #ff3c6e; }

      .amt-tt-title {
        font-family   : 'Orbitron', monospace;
        font-size     : 13px; font-weight: 700;
        color         : #e8f4f8;
        letter-spacing: 1.5px; margin-bottom: 10px;
      }
      .amt-tt-body {
        font-size: 15px; color: #7aafc4;
        line-height: 1.55; margin-bottom: 18px; font-weight: 400;
      }
      .amt-tt-body strong { color: #e8f4f8; font-weight: 700; }
      .amt-tt-foot {
        display: flex; flex-direction: column; gap: 8px;
      }

      .amt-btn-next {
        background: #00e5ff; color: #020c1b; border: none;
        padding: 11px 20px; font-family: 'Orbitron', monospace;
        font-size: 11px; font-weight: 700; letter-spacing: 2px;
        cursor: pointer; transition: all 0.2s; width: 100%;
        clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px,
                           100% 100%, 8px 100%, 0 calc(100% - 8px));
      }
      .amt-btn-next:hover {
        background: #33ecff;
        box-shadow: 0 0 20px rgba(0,229,255,0.45);
      }

      .amt-btn-end {
        background: transparent; color: #3d6070;
        border: 1px solid #0d2a4e; padding: 8px 16px;
        font-family: 'Orbitron', monospace;
        font-size: 9px; letter-spacing: 2px;
        cursor: pointer; transition: all 0.2s; width: 100%;
      }
      .amt-btn-end:hover { color: #ff3c6e; border-color: #ff3c6e; }

      .amt-click-cue {
        display: flex; align-items: center; gap: 10px;
        color: #00e5ff; font-family: 'Orbitron', monospace;
        font-size: 10px; letter-spacing: 1.5px;
        padding: 10px 0 4px;
        animation: amt-pulse 1.6s ease-in-out infinite;
      }
      .amt-click-cue svg {
        animation: amt-bounce 1.2s ease-in-out infinite;
        flex-shrink: 0;
      }

      @keyframes amt-pulse  { 0%,100%{opacity:1;} 50%{opacity:0.45;} }
      @keyframes amt-bounce { 0%,100%{transform:translateY(0);} 50%{transform:translateY(5px);} }

      /* ── Shake animation for clickable targets ── */
      @keyframes amt-shake {
        0%,100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0,229,255,0); }
        15%     { transform: scale(1.04) translateX(-3px); }
        30%     { transform: scale(1.04) translateX(3px); box-shadow: 0 0 20px rgba(0,229,255,0.5); }
        45%     { transform: scale(1.04) translateX(-2px); }
        60%     { transform: scale(1.04) translateX(2px); }
        75%     { transform: scale(1.02) translateX(0); box-shadow: 0 0 30px rgba(0,229,255,0.3); }
      }
      .amt-shake {
        animation: amt-shake 0.9s ease forwards !important;
        outline   : 2px solid #00e5ff !important;
        outline-offset: 3px !important;
      }

      @media (max-width: 767px) {
        #amt-tour-tooltip {
          width  : calc(100vw - 32px) !important;
          left   : 16px !important;
          right  : 16px !important;
          top    : auto !important;
          bottom : 16px !important;
          clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px,
                             100% 100%, 10px 100%, 0 calc(100% - 10px));
        }
        #amt-page-announce {
          top  : 16px;
          right: 16px;
        }
        .amt-announce-line2 { font-size: 14px; }
      }
    `;
    document.head.appendChild(s);
  }

  function injectFonts() {
    if (document.querySelector('link[href*="Orbitron"]')) return;
    const l   = document.createElement('link');
    l.rel  = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Orbitron:wght@700&family=Rajdhani:wght@400;500&display=swap';
    document.head.appendChild(l);
  }

  // ─── GO ────────────────────────────────────────────────────────────────────
  init();

})();